<template>
  <button class="btn btn-info" @click.prevent="add" ref="button">
    <i class="fa fa-fw fa-plus" aria-hidden="true" />

    <slot>Dodaj wiersz</slot>
  </button>
</template>

<script>
export default {
  name: 'w-add-row',
  props: {
    model: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      default: 1
    },
    rowDefault: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    add() {
      this.model.$addRow({...this.rowDefault}, this.count);
      this.$emit('rowAdded', this.count);
      this.$nextTick(() => {
        this.focusLastRow();
      });
    },
    focusLastRow() {
      if (typeof this.$refs.button.closest !== 'function' || typeof this.$refs.button.querySelector !== 'function') {
        return;
      }

      const tbody = this.$refs.button.closest('tbody');
      if (tbody) {
        const row = tbody.querySelector('tr:last-child');
        if (row) {
          const field = row.querySelector('input,select,textarea');
          if (field) {
            field.focus();
            return;
          }
        }
      }

      const row = this.$refs.button.closest('table').querySelector('tbody > tr:last-child');
      if (!row) {
        return;
      }

      const field = row.querySelector('input,select,textarea');
      if (!field) {
        return;
      }

      field.focus();
    }
  }
};
</script>
